module.exports = __webpack_public_path__ + "static/img/banner-perfil-home-1680x1050.17e05fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-perfil-home-1680x1050.jpg
// module id = 5ycN
// module chunks = 47